export function generateStatCardId(): string {
  return `custom-stat-card-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
}

export function generateChartId(): string {
  return `custom-chart-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
}
